'use strict';

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = require('./util'),
    get = _require.get,
    is = _require.is,
    arr = _require.arr,
    num = _require.num,
    px = _require.px,
    breaks = _require.breaks,
    dec = _require.dec,
    media = _require.media,
    merge = _require.merge;

module.exports = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (props) {
    // support for legacy API
    var arg = args[0],
        _prop = args[1],
        _bool = args[2];

    var _ref = typeof arg === 'string' ? { cssProperty: arg, prop: _prop, boolValue: _bool } : arg,
        cssProperty = _ref.cssProperty,
        prop = _ref.prop,
        boolValue = _ref.boolValue,
        key = _ref.key,
        numberToPx = _ref.numberToPx;

    prop = prop || cssProperty;
    var n = props[prop];
    if (!is(n)) return null;

    var bp = breaks(props);
    var scale = get(props, ['theme', key || prop].join('.'), {});
    var sx = function sx(val) {
      return get(scale, '' + val, numberToPx ? px(val) : val);
    };

    if (!Array.isArray(n)) {
      return (0, _defineProperty3.default)({}, cssProperty, sx(bool(boolValue)(n)));
    }

    var val = arr(n);
    return val.map(bool(boolValue)).map(sx).map(dec(cssProperty)).map(media(bp)).reduce(merge, {});
  };
};

var bool = function bool(val) {
  return function (n) {
    if (Array.isArray(val)) return n === true ? val[0] : val[1];

    return n === true ? val : n;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/responsive-style.js
// module id = 22
// module chunks = 168707334958949